import StaffCarousel from './staffCarousel'

export default StaffCarousel